document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.custom-slider');

  sliders.forEach(slider => {
    const slidesWrapper = slider.querySelector('.slides');
    const slides = Array.from(slidesWrapper.querySelectorAll('img'));
    const prevBtn = slider.querySelector('.slider-nav.prev');
    const nextBtn = slider.querySelector('.slider-nav.next');

    let currentIndex = slides.findIndex(img => img.classList.contains('active'));
    if (currentIndex < 0) currentIndex = 0;

    function showSlide(idx) {
      if (idx < 0) {
        idx = slides.length - 1;
      } else if (idx >= slides.length) {
        idx = 0;
      }
      slides.forEach((img, i) => {
        img.classList.toggle('active', i === idx);
      });
      currentIndex = idx;
    }
    if(!prevBtn) return;
    prevBtn.addEventListener('click', () => {
      showSlide(currentIndex - 1);
    });
    if(!nextBtn) return;
    nextBtn.addEventListener('click', () => {
      showSlide(currentIndex + 1);
    });
  });
});
